import { useEffect } from 'react';

import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';
import useStructuredFilterQuery from '@/features/StructuredFilter/hooks/useStructuredFilterQuery';
import StructuredFilter from '@/features/StructuredFilter/StructuredFilter';
import structuredFilterUtils from '@/features/StructuredFilter/utils/structuredFilter.utils';
import useStructuredFilter from '@/hooks/domain/App/useStructuredFilter';

type Props = {
  chartInfo: ChartContextProps;
};

const ChartDataFilter = (props: Props) => {
  const { chartInfo } = props;
  const { parseStructuredFilter } = useStructuredFilter();
  const { state } = chartInfo;
  const { onFeedbackFilterChange, resetFeedbackFilter } =
    useChartStateAction(chartInfo);

  const {
    filterQueryFormats: currFilterSetQuery,
    onFilterSetChange,
    clearFilter,
  } = useStructuredFilterQuery();

  const onFeedbackFilterChangeHandler = (
    values: StructuredFilterQueryFormatT[],
  ) => {
    onFilterSetChange(values);

    const filter = structuredFilterUtils.buildStructuredFilter(values);
    onFeedbackFilterChange(filter);
  };

  const resetFeedbackFilterHandler = () => {
    clearFilter();
    resetFeedbackFilter();
  };

  useEffect(() => {
    const formats = parseStructuredFilter(state.target.filter || {});
    onFilterSetChange(formats);
  }, []);

  return (
    <StructuredFilter
      values={currFilterSetQuery}
      onChange={onFeedbackFilterChangeHandler}
      clearFilter={resetFeedbackFilterHandler}
    />
  );
};

export default ChartDataFilter;
